import { ApiService, toBodyModel, toModels } from '~/shared/api'
import {
  ResearchShowcaseCard,
  ResearchShowcaseFilters,
  ResearchShowcaseQueryResult,
} from '~/models/research-showcase'
import { API_PREFIX } from '~/shared/const/request-services'

type QueryParams = Record<string, string | number>

export class ResearchShowcaseMainService extends ApiService {
  readonly urls = {
    filters: `${API_PREFIX}/research-showcase-cards/filters`,
    query: `${API_PREFIX}/research-showcase-cards/query`,
    random: `${API_PREFIX}/research-showcase-cards/random`,
  }

  getFilters(params: QueryParams = {}): Promise<ResearchShowcaseFilters> {
    return this.http
      .request({ url: this.urls.filters, params })
      .then(toBodyModel(ResearchShowcaseFilters))
  }

  getQuery(params: QueryParams = {}): Promise<ResearchShowcaseQueryResult> {
    return this.http
      .request({
        url: this.urls.query,
        params: { sort: '-date_publication', 'page[size]': 30, ...params },
      })
      .then(toBodyModel(ResearchShowcaseQueryResult))
  }

  getRandom(excludeIds: number[] = []): Promise<ResearchShowcaseCard[]> {
    const params: QueryParams = {}
    if (excludeIds.length) {
      params['filter[exclude_ids]'] = excludeIds.join(',')
    }

    return this.http.request({ url: this.urls.random, params }).then(toModels(ResearchShowcaseCard))
  }
}
